// Used to configure the default colors and styling of Material UI
import { createTheme, Theme } from '@mui/material';

import colors from '@atom/styles/colors';

declare module '@mui/styles' {
  interface DefaultTheme extends Theme {}
}

export const muiTheme = createTheme({
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
  palette: {
    primary: {
      main: colors.brand.blue,
    },
    text: {
      primary: colors.neutral.dark,
    },
  },
});
